<script setup lang="ts">
const { t } = useI18n();

useSchemaOrg([
  defineWebPage({
    name: t('schema_title'),
    datePublished: new Date(2022, 4, 27, 20).toISOString(),
  }),
]);

definePageMeta({ landing: true });
</script>

<template>
  <main class="relative">
    <Head>
      <Title>{{ t('meta.about_fants.title') }}</Title>
      <Meta name="description" :content="t('meta.about_fants.description')" />
      <Meta name="keywords" :content="t('meta.about_fants.keywords')" />
      <Meta property="og:title" :content="t('meta.about_fants.title')" />
      <Meta
        property="og:description"
        :content="t('meta.about_fants.description')"
      />
    </Head>

    <SectionAboutFantsLevels />
    <SectionAboutFantsDescriptions />
    <SectionAboutFantsGallery />
    <SectionAboutFantsToInterests />
    <LayoutFooter />

    <Button
      as="nuxt-link"
      to="/game/settings"
      rounded
      :label="t('start_the_game')"
      size="large"
      class="!fixed right-1/2 md:right-12 bottom-12 z-10 translate-x-1/2 md:translate-x-0 px-6 sm:px-8 text-xl"
    />
  </main>
</template>

<i18n src="~/locales/meta.yaml"></i18n>
<i18n>
en:
  schema_title: About sex tasks
  start_the_game: Start the game

ru:
  schema_title: О фантах и секс заданиях
  start_the_game: Начать игру

de:
  schema_title: Über Verluste und Sexaufgaben
  start_the_game: Spiel starten

es:
  schema_title: Sobre pérdidas y tareas sexuales.
  start_the_game: iniciar juego

fr:
  schema_title: À propos des forfaits et des tâches sexuelles
  start_the_game: Commencer le jeu
</i18n>
